/**
 * The "Flexible Amount" settings shared by the Payment Link Generator page and
 * PaymentLinkModal: optional minimum per payment, optional pay-by date, and a preview.
 *   form      { amount, minPayment, payBy, currency }
 *   onChange  standard input change handler (uses each field's `name`)
 */
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { lightDark, darkTint, DARK } from "utils/lightDark";
import { flexiblePreviewText } from "utils/flexiblePayment";

const BOX_BORDER = lightDark("1px solid #c5cae9", `1px solid ${DARK.border}`);

export default function FlexibleLinkFields({ form, onChange }) {
  const today = new Date().toISOString().split("T")[0];
  const preview = flexiblePreviewText(form);

  return (
    <MDBox
      sx={{
        background: lightDark("#f0f4ff", darkTint("#1a73e8", 0.08)),
        borderRadius: 2,
        p: 2,
        mb: 2,
        border: BOX_BORDER,
      }}
    >
      <MDTypography variant="caption" fontWeight="bold" color="info" display="block" mb={1.5}>
        Flexible Amount Settings
      </MDTypography>
      <Grid container spacing={2} mb={preview ? 1.5 : 0}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Minimum per payment (optional)"
            name="minPayment"
            type="number"
            value={form.minPayment}
            onChange={onChange}
            fullWidth
            size="small"
            inputProps={{ min: 0, step: "0.01" }}
            helperText="Blank = any amount from the gateway minimum"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Pay-by date (optional)"
            name="payBy"
            type="date"
            value={form.payBy}
            onChange={onChange}
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            inputProps={{ min: today }}
            helperText="Blank = the link stays open until paid"
          />
        </Grid>
      </Grid>
      {preview && (
        <MDTypography variant="caption" color="text" display="block">
          {preview}
        </MDTypography>
      )}
    </MDBox>
  );
}
